import React, { useContext } from 'react'

import PropTypes from 'prop-types'
import Context from '../../context'
import PurchaseInfo from '../PurchaseInfos'
import TextAreaHtml from '../TextAreaHtml'
import WeekDayForm from '../WeekDaysForm'

function ContractForm({ editUnity, showAmenities, checkValue, checkIsRed }) {
  const { amenities, setAmenities, formObject, setFormObject } = useContext(Context)

  const handleAmenities = id => {
    const newArr = amenities.map(item => {
      if (item.id === id) {
        return { ...item, selected: !item.selected }
      }
      return { ...item }
    })

    setAmenities([...newArr])
  }

  const handleTextArea = value => {
    setFormObject({ ...formObject, roles: value })
    checkValue('contractRoles', value)
  }
  const handleTextAreaVip = value => {
    setFormObject({ ...formObject, partnerVipRoles: value })
  }

  return (
    <>
      <h5>Informações Contratuais</h5>
      <div className="form-row">
        <TextAreaHtml
          handleEditor={handleTextArea}
          placeholder="Descreva o regulamento do contrato"
          value={formObject.roles}
          disabled={editUnity}
          checkIsRed={checkIsRed}
          strToCheckIsRed="contractRoles"
        />
      </div>

      <div className="form-row">
        <div className="form-group col">
          <div className="input-group">
            <input
              value={formObject.discountAmount || ''}
              onChange={e =>
                setFormObject({
                  ...formObject,
                  discountAmount: e.target.value
                })
              }
              type="number"
              className="form-control"
              placeholder="Percentagem do Desconto"
              disabled={editUnity}
            />
            <div className="input-group-append">
              <span className="input-group-text">%</span>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="form-check form-group">
            <input
              className="form-check-input"
              type="checkbox"
              id="hasCourtesy"
              checked={formObject.hasCourtesy}
              onChange={() =>
                setFormObject({
                  ...formObject,
                  hasCourtesy: !formObject.hasCourtesy
                })
              }
              disabled={editUnity}
            />
            <label htmlFor="hasCourtesy" className="form-check-label">
              Possui Algum Bônus?
            </label>
          </div>
        </div>
        <div className="col">
          <div className="form-check form-group">
            <input
              className="form-check-input"
              type="checkbox"
              id="hasDelivery"
              checked={formObject.hasDelivery}
              onChange={() =>
                setFormObject({
                  ...formObject,
                  hasDelivery: !formObject.hasDelivery
                })
              }
              disabled={editUnity}
            />
            <label htmlFor="hasDelivery" className="form-check-label">
              É válido para o Delivery?
            </label>
          </div>
        </div>
      </div>

      {showAmenities && (
        <>
          <div className="form-row facilities">
            {amenities.length > 0 &&
              amenities.map((amenity, i) => (
                <div key={`${amenity.id + i}`} className="col">
                  <div className="form-check form-group align-items-center">
                    <input
                      checked={amenity.selected}
                      onChange={() => handleAmenities(amenity.id)}
                      className="form-check-input"
                      type="checkbox"
                      id={amenity.id}
                    />
                    <label htmlFor={amenity.id} className="form-check-label">
                      {amenity.name}
                    </label>
                  </div>
                </div>
              ))}
          </div>
          <WeekDayForm editUnity />
        </>
      )}

      <PurchaseInfo checkIsRed={checkIsRed} checkValue={checkValue} />

      {!editUnity && (
        <>
          <div className="form-row">
            <label className="col-3 padding-bottom-label" htmlFor="vipRoles">
              Tipo do Parceiro
            </label>
            <div className="col-3 d-flex flex-row">
              <select
                className="custom-select"
                id="vipRoles"
                onChange={e =>
                  setFormObject({
                    ...formObject,
                    partnerType: Number(e.target.value)
                  })
                }
                defaultValue={`${formObject.partnerType}`}
              >
                <option value="1">Normal</option>
                <option value="2">VIP</option>
                <option value="3">Normal e VIP</option>
              </select>
            </div>
          </div>
          {formObject.partnerType !== 1 && (
            <>
              <h5 style={{ marginTop: 20 }}>Regras para o VIP</h5>
              <div className="row">
                <TextAreaHtml
                  value={formObject.partnerVipRoles || ''}
                  handleEditor={handleTextAreaVip}
                  placeholder="Descrição das regras VIP"
                />
              </div>
            </>
          )}
        </>
      )}
    </>
  )
}

ContractForm.defaultProps = {
  editUnity: false,
  showAmenities: false,
  checkValue: () => {},
  checkIsRed: () => {}
}

ContractForm.propTypes = {
  editUnity: PropTypes.bool,
  showAmenities: PropTypes.bool,
  checkValue: PropTypes.func,
  checkIsRed: PropTypes.func
}

export default ContractForm
